// extracted by mini-css-extract-plugin
export var container = "_f8-1";
export var cornerButtonContainer = "_f8-6";
export var disabled = "_f8-2";
export var dragActive = "_f8-3";
export var fileContainer = "_f8-5";
export var hiddenInput = "_f8-4";
export var widthContainer = "_f8-0";